import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export interface MileMarkerProps extends SvgIconProps {
  mile?: number;
}

export default function MileMarkerWithNumber({ mile, ...props }: MileMarkerProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect fill="#0277BD" height="13" width="5" x="10" y="9" />
      <path
        d="M21.4286 2C22.8487 2 24 3.34315 24 5V14C24 15.6569 22.8487 17 21.4286 17H2.57143C1.15127 17 0 15.6569 0 14V5C0 3.34315 1.15127 2 2.57143 2H21.4286Z"
        fill="#0277BD"
      />

      {mile != null && (
        <text
          dominantBaseline="middle"
          fill="#fff"
          fontSize="8"
          fontWeight="bold"
          textAnchor="middle"
          x="12"
          y="10"
        >
          {mile}
        </text>
      )}
    </SvgIcon>
  );
}
